// components
import { BoxProps, Box, styled } from '@mui/material';

export const StyledNotesContainerBox = styled(Box)<BoxProps>(({ theme }) => ({
  height: '100%',
  margin: theme.spacing(-10, -5, 0, -5),
  padding: theme.spacing(14, 5, 5),
  backgroundColor: theme.palette.background.default,
  position: 'relative'
}));

export const WavyTopBar = styled('div', {
  shouldForwardProp: (p) => p !== 'waveSize'
})<{ waveSize?: number }>(({ theme, waveSize = 32 }) => {
  const barColor = theme.palette.background.paper;
  const mask = `radial-gradient(12.5px at 50% calc(100% - 17.6px),#000 99%,#0000 101%) calc(50% - ${
    waveSize / 2
  }px) 0/${waveSize}px 100%,
    radial-gradient(12.5px at 50% calc(100% + 9.6px),#0000 99%,#000 101%) 50% calc(100% - ${
      waveSize / 4
    }px)/${waveSize}px 100% repeat-x`;

  return {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: waveSize,
    backgroundColor: barColor,
    pointerEvents: 'none',
    WebkitMask: mask,

    /* Safari + Chromium */
    WebkitMaskImage: mask,
    WebkitMaskRepeat: 'repeat-x',
    WebkitMaskSize: `${waveSize}px ${waveSize}px`,

    /* Firefox */
    maskImage: mask,
    maskRepeat: 'repeat-x',
    maskSize: `${waveSize}px ${waveSize}px`
  };
});
